module.exports = __webpack_public_path__ + "static/media/view candidate info.c4c18b83.svg";